import {
  Box,
  Button,
  Dialog,
  DialogContent,
  IconButton,
  Typography,
} from "@mui/material";
import { CatalogItem } from "../../app/backendTypes";
import { useContext, useState } from "react";
import { HttpClientContext, X_REQUEST_ID } from "../../app/client";
import { AxiosError } from "axios";
import { LoadingButton } from "@mui/lab";
import { Close } from "@mui/icons-material";
import Morselbar from "../common/Morselbar";
import { useNavigate } from "react-router-dom";

export function RemoveCatalog(props: {
  catalog: CatalogItem;
  callback: () => void;
}) {
  const { catalog, callback } = props;

  const [open, setOpen] = useState(false);
  const [loading, setLoading] = useState(false);
  const [messageOpen, setMessageOpen] = useState(false);
  const [message, setMessage] = useState<{
    error?: string;
    content: string;
  }>({ content: "" });

  const client = useContext(HttpClientContext);

  const navigate = useNavigate();

  const handleSubmit = (catalog: CatalogItem) => {
    setLoading(true);
    setMessageOpen(false);
    setMessage({ content: "" });

    client
      ?.delete(`/api/catalog/${catalog.id}`)
      .then(() => {
        setMessage({
          error: undefined,
          content: "Removed catalog item",
        });
        setMessageOpen(true);
        setOpen(false);
        callback();
        navigate("/catalog");
      })
      .catch((e: AxiosError) => {
        setMessage({
          error: e.response?.headers[X_REQUEST_ID],
          content: "Failed to remove catalog item",
        });
        setMessageOpen(true);
      })
      .finally(() => setLoading(false));
  };

  return (
    <>
      <Button variant="outlined" onClick={() => setOpen(true)} color="error">
        Remove Item
      </Button>

      <Dialog open={open}>
        <DialogContent>
          <Box
            sx={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              gap: 2,
            }}
          >
            <Typography color="text.secondary">
              This action will{" "}
              <Typography component="span" color="error">
                remove
              </Typography>{" "}
              the catalog item{" "}
              <Typography component="span" color="secondary">
                {catalog.info.display_name}
              </Typography>
            </Typography>
            <IconButton onClick={() => setOpen(false)}>
              <Close />
            </IconButton>
          </Box>
          <br />
          <Box display="flex" justifyContent="flex-end">
            <LoadingButton
              loading={loading}
              variant="outlined"
              color="error"
              onClick={() => handleSubmit(catalog)}
            >
              Confirm
            </LoadingButton>
          </Box>
        </DialogContent>
      </Dialog>

      <Morselbar
        open={messageOpen}
        setOpen={setMessageOpen}
        content={message.content}
        error={message.error}
      />
    </>
  );
}
